import { ReactNode } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import MobileCTA from './MobileCTA';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pb-14 md:pb-0">{children}</main>
      <Footer />
      <MobileCTA />
    </div>
  );
}
